const iconTypes = Object.freeze({
  check: 'check',
  add: 'add',
  reportProblem: 'reportProblem',
  error: 'error',
  ignored: 'ignored',
});

export default iconTypes;
